import { BaseFaxMedicalRequestComposite } from "./BaseFaxMedicalRequestComposite";

class FaxLabRequestComposite extends BaseFaxMedicalRequestComposite {
    public RequestId: string = this.Id;
    public FileName: string = this.PdfFileName;

    public LabName: string;
    public LabFax: string;
    public LabPhone: string;
    public LabAddress: string;

    constructor(fields: Partial<FaxLabRequestComposite>) {
        super(fields.Id, fields.PatientId, fields.PdfFileName);
        (Object as any).assign(this, fields);
    }
}

export { FaxLabRequestComposite };
